import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import NftCard from '../Card/NftCard';
import { doc, getDoc } from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { skeleTonJson } from '../common/jsonDumb';
import { Document } from 'postcss';
// import fi from ""
// import { firebaseFireStore } from '../../config/firebaseFirestore'

export default function LikedNfts(props) {
  const userDataRedux = useSelector((state) => state.authReducer.userData);

  const [likedNfts, setlikedNfts] = useState([]); //wallet nfts
  const [loadingNfts, setloadingNfts] = useState(true);

  useEffect(() => {
    if (userDataRedux) {
      getUserLikedNfts();
    }
  }, [userDataRedux]);

  const setlikedNftsLoading = (customId) => {
    setlikedNfts(
      likedNfts?.map((nft) => {
        if (nft.customId === customId) {
          return {
            ...nft,
            loading: false,
          };
        }
        return nft;
      }),
    );
  };
  const userLikedNfts = async () => {
    // const docRef = doc(firebaseFireStore, musicartUserData, userDataRedux.uid, "musicartNfts");
    let dataRef = await getDoc(
      doc(
        firebaseFireStore,
        musicartUserData,
        userDataRedux.uid,
        'userDetails',
        'likedNfts',
      ),
    );
  };
  const getUserLikedNfts = async () => {
    try {
      // let nftArr = []
      console.log('get like nfts');
      let dataArr = [];
      setloadingNfts(true);
      let dataRef = await getDoc(
        doc(
          firebaseFireStore,
          'musicartUserData',
          userDataRedux.uid,
          'userDetails',
          'likedNfts',
        ),
      );

      // setlikedNfts(nftArr)
      if (dataRef.data() && dataRef.data().likedNfts) {
        let nftArr = dataRef.data().likedNfts;
        console.log('loading data', nftArr);

        await Promise.all(
          nftArr.map(async (ele, index) => {
            let nftDataMain = await getDoc(
              doc(firebaseFireStore, 'musicartNfts', ele),
            );

            if (nftDataMain.data()) {
              let cObj = nftDataMain.data();
              if (cObj.isMultiple && Number(cObj.nftQuantity) > 1) {
                let startingPrice = 0;
                Object.values(cObj.multipleNftDetails)
                  .filter((x) => x.activeInMarketPlace)
                  .map((ele, index) => {
                    if (
                      ele.adminState === 'ACCEPT' &&
                      ele.activeInMarketPlace
                    ) {
                      if (
                        ele.nftSaleType &&
                        ele.nftSaleType !== 'Auctioning' &&
                        ele.price &&
                        (!startingPrice ||
                          (startingPrice && Number(ele.price) < startingPrice))
                      ) {
                        startingPrice = Number(ele.price);
                      } else if (
                        ele.nftSaleType &&
                        ele.nftSaleType === 'Auctioning' &&
                        ele.auctionEndTime &&
                        ele.minBiddingPrice &&
                        (!startingPrice ||
                          (startingPrice &&
                            Number(ele.minBiddingPrice) < startingPrice))
                      ) {
                        startingPrice = Number(ele.minBiddingPrice);
                      }
                    }
                  });
                if (startingPrice || cObj.preview) {
                  dataArr.push({ ...cObj, startingPrice: startingPrice });
                }
              } else {
                if (
                  (cObj.nftSaleType &&
                    cObj.nftSaleType === 'Auctioning' &&
                    cObj.auctionEndTime &&
                    cObj.minBiddingPrice) ||
                  (cObj.nftSaleType !== 'Auctioning' && cObj.price) ||
                  cObj.preview
                ) {
                  dataArr.push(cObj);
                }
              }
            }
          }),
        );
      }

      console.log('dataArr', dataArr);
      setlikedNfts(dataArr);
      setloadingNfts(false);
    } catch (err) {
      setlikedNfts([]);
      setloadingNfts(false);
    }
  };
  const removelikednft = (index) => {
    setlikedNfts(
      likedNfts.filter((x) => {
        return x.tokenId !== index;
      }),
    );
  };
  const reloadlikednfts = (arr) => {
    // setlikedNfts(arr)
  };

  return (
    <div>
      <div className="row" key="1">
        {loadingNfts &&
          skeleTonJson.slice(0, 4).map((ele, index) => (
            <div
              style={{ display: 'block' }}
              className="turning-screens 2xl:w-2/12 xl:w-5/12 lg:w-3/12 md:w-4/12"
              key={'nft-' + index + ele.tokenId}
            >
              <NftCard
                // nftDataArr={nftDataArr}
                ele={ele}
                index={index}
                // setNFTDataArr={setNFTDataArr}
              />
            </div>
          ))}
        {likedNfts.length === 0 ? (
          !loadingNfts && (
            <div className="no__result__alert">No result found</div>
          )
        ) : (
          <>
            {likedNfts.map((ele, index) => {
              return (
                <div
                  style={{ display: 'block' }}
                  className="turning-screens 2xl:w-2/12 xl:w-5/12 lg:w-3/12 md:w-4/12"
                  key={'nft-' + index + ele.tokenId}
                >
                  <NftCard
                    nftDataArr={likedNfts}
                    ele={ele}
                    index={index}
                    setnftDataArr={reloadlikednfts}
                    reloadlikednfts={removelikednft}
                    category={'collection_liked_nfts'}
                  />
                </div>
              );
            })}
          </>
        )}
      </div>
    </div>
  );
}
